// extracted by mini-css-extract-plugin
export default {"shine_btn":"styles_shine_btn__rsuYp"};